import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

import { httpClient } from '../../httpClient'

export type IdeaRegistry = {
  id: string
  title: string
  description: string
  date: string
  dateISO: string
  user: {
    name: string
    email: string
  }
}

type IdeaRegistryHttpResponse = {
  historyItem: {
    id: string
    title: string
    description: string
    date: string
    user: {
      name: string
      email: string
    }
  }[]
  paginate: {
    page: number
    pages: number
  }
  hasMorePages?: boolean
}

export type IdeaRegistriesResult = {
  ideaRegistries: IdeaRegistry[]
  hasMorePages: boolean
}

const LIMIT = 5

export async function getIdeaRegistries(
  id: string,
  page: number,
): Promise<IdeaRegistriesResult> {
  const { data } = await httpClient.get<IdeaRegistryHttpResponse>(
    `ideas/ideas/${id}/history`,
    {
      params: {
        page,
        limit: LIMIT,
      },
    },
  )

  const ideaRegistries: IdeaRegistry[] =
    data.historyItem.map((historyItem) => ({
      id: historyItem.id,
      title: historyItem.title,
      description: historyItem.description,
      date: format(parseISO(historyItem.date), "dd MMM'.' yyyy 'às' HH:mm", {
        locale: ptBR,
      }),
      dateISO: historyItem.date,
      user: historyItem.user,
    })) || []

  const hasMorePages =
    data.hasMorePages ?? data.paginate.page < data.paginate.pages

  return { ideaRegistries, hasMorePages }
}
